import { OsmVersionStatusType } from 'app/models/enums';

export class OsmVersion {
  constructor(
    public readonly id: number,
    public readonly schemaName: string,
    public readonly status: OsmVersionStatusType,
    public readonly mutationUser: string,
    public readonly importDate: Date,
    public readonly approveDate: Date,
    public readonly deleteDate: Date,
    public readonly version: string
  ) {}
}



// WEBPACK FOOTER //
// ./src/app/models/osmversion.model.ts